import logger from './logUtils';
import { fptiConstants } from '../constants/logConstant';
import serverData from './server-data';

const TrackingConstants = {
    app: 'cponboardingnodeweb',
    technologyFlag: 'Nodejs',
    product: 'zettle'
};

const userAttributes = {};

export const initUserAttributes = ({ accountId } = {}) => {
    const { experimentation = {} } = serverData;
    userAttributes.comp = TrackingConstants.app;
    userAttributes.pgtf = TrackingConstants.technologyFlag;
    userAttributes.product = TrackingConstants.product;

    userAttributes.ccpg = serverData.locality?.country;
    userAttributes.acnt = serverData.user?.accountType;
    userAttributes.encr_cust_id =
        serverData.user?.encryptedAccountNumber || accountId;

    /**
     * TODO: need to confirm further, once the tag manager enable experiment within amplitude
     */
    userAttributes.xe = Object.keys(experimentation).toString(); // ELMO experiment ids
    userAttributes.xt = Object.values(experimentation).toString(); // ELMO treatment ids
};

/**
 * extract UTM tags from `window.laDataLayer` in order to set in client events.
 * @returns {{utm_campaign: String, utm_medium: String, utm_source: String}}
 */
export const getUTMParams = () => {
    const { utm_source, utm_medium, utm_campaign, utm_content, utm_term } =
        window.laDataLayer || {};
    return { utm_source, utm_medium, utm_campaign, utm_content, utm_term };
};

/**
 * We can use this file to initialize any needed data during analytics setup
 * PA.js has a 500ms delay between its inception and setup initialization, and we need to know when
 * the setup is really complete before firing our analytic calls.
 * @param {object} PAYPAL window.PAYPAL from pa.js
 * @param {function} callback
 * @param {Number} retries
 */
export const initAnalytics = (PAYPAL = {}, callback, retries = 40) => {
    if (PAYPAL.analytics) {
        return callback();
    }

    // wait up to 6s for analytics to initialize
    // otherwise give up analytics eventually
    if (retries-- <= 0) return false;

    return setTimeout(() => {
        initAnalytics(PAYPAL, callback, retries);
    }, 150);
};

/**
 * Set up analytics with initialized data to global PAYPAL
 */
export const setupAnalytics = () => {
    const PAYPAL = window.PAYPAL;

    try {
        let options = {};
        initUserAttributes();

        options.customizedData = {
            isReady: true
        };
        PAYPAL.analytics.setup(options);
    } catch (e) {
        logger.error(fptiConstants.FPTI_SETUP, { error: e.message });
    }
};

export default userAttributes;
